import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Header from "../Layout/Header";
import "./AddConflictOfInterestDeclaration.css";

const PROJECTS_OPTIONS = [
  { value: "", label: "No project (general declaration)" },
  { value: "1", label: "Project Alpha" },
  { value: "2", label: "Project Beta" },
  { value: "3", label: "Project Gamma" }
];

const emptyDeclaration = {
  id: null,
  project: "",
  has_conflict: true,
  details: "",
  mitigation: ""
};

const AddConflictOfInterestDeclaration = () => {
  const navigate = useNavigate();

  const [declarations, setDeclarations] = useState([
    { ...emptyDeclaration }
  ]);

  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    setDeclarations((prev) =>
      prev.map((c, i) =>
        i === index
          ? { ...c, [name]: type === "checkbox" ? checked : value }
          : c
      )
    );
  };

  const toggleHasConflict = (index) => {
    setDeclarations((prev) =>
      prev.map((c, i) =>
        i === index ? { ...c, has_conflict: !c.has_conflict } : c
      )
    );
  };

  const addDeclaration = () => {
    setDeclarations((prev) => [...prev, { ...emptyDeclaration }]);
  };

  const removeDeclaration = (index) => {
    setDeclarations((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length ? next : [{ ...emptyDeclaration }];
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Declarations:", declarations);
  };

  const handleCancel = () => {
    navigate("/admin/coi-declarations");
  };

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="coi-page">
          <div className="coi-page-header">
            <div>
              <h2>Conflict of Interest Declarations</h2>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="coi-card">
              <div className="coi-form-body">
                {declarations.map((c, index) => (
                  <div className="coi-record" key={index}>
                    <div className="coi-record-header">
                      <h4>Declaration {index + 1}</h4>

                      <button
                        type="button"
                        className="coi-remove-btn"
                        onClick={() => removeDeclaration(index)}
                      >
                        Remove
                      </button>
                    </div>

                    <div className="coi-form-grid">
                      <div className="coi-form-group">
                        <label>Project</label>
                        <select
                          name="project"
                          value={c.project}
                          onChange={(e) => handleChange(index, e)}
                        >
                          {PROJECTS_OPTIONS.map((p) => (
                            <option key={p.value} value={p.value}>
                              {p.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="coi-status-field">
                        <label>Has Conflict</label>
                        <label className="coi-switch">
                          <input
                            type="checkbox"
                            checked={c.has_conflict}
                            onChange={() => toggleHasConflict(index)}
                          />
                          <span className="coi-slider"></span>
                        </label>
                        <span className="coi-status-label">
                          {c.has_conflict ? "Conflict declared" : "No conflict"}
                        </span>
                      </div>

                      <div className="coi-form-group coi-form-group--full">
                        <label>Details</label>
                        <textarea
                          name="details"
                          value={c.details}
                          onChange={(e) => handleChange(index, e)}
                          rows={4}
                        />
                      </div>

                      <div className="coi-form-group coi-form-group--full">
                        <label>Mitigation</label>
                        <textarea
                          name="mitigation"
                          value={c.mitigation}
                          onChange={(e) => handleChange(index, e)}
                          rows={4}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  className="coi-add-btn"
                  onClick={addDeclaration}
                >
                  <span>+</span>
                  Add Another Declaration
                </button>
              </div>
            </div>

            <div className="coi-form-actions">
              <button
                type="button"
                className="coi-cancel-btn"
                onClick={handleCancel}
              >
                Cancel
              </button>

              <button type="submit" className="coi-save-btn">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddConflictOfInterestDeclaration;